import { render, staticRenderFns } from "./ScreenIndicator.vue?vue&type=template&id=fbc91dc2"
import script from "./ScreenIndicator.vue?vue&type=script&lang=js"
export * from "./ScreenIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc91dc2')) {
      api.createRecord('fbc91dc2', component.options)
    } else {
      api.reload('fbc91dc2', component.options)
    }
    module.hot.accept("./ScreenIndicator.vue?vue&type=template&id=fbc91dc2", function () {
      api.rerender('fbc91dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/ScreenIndicator.vue"
export default component.exports